import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserManagementService {
  public userDetails: any;
  public userRole = '';

  constructor(private authService: AuthService) {
    this.getUserDetails();
  }

  private getUserDetails() {
    this.userDetails = this.authService.getUserInfo();
    this.userRole = this.authService.getUserRole();
  }

  public getEmail(): string {
    return this.userDetails['email']?.trim();
  }

  public getName(): string {
    return this.userDetails['name']?.trim();
  }

  public getOrgId(): string {
    return this.userDetails?.['custom:orgId']?.trim();
  }

  public getUserRole() {
    return this.userRole;
  }

  public getUserGroups(): string[] {
    return this.userDetails?.groups || [];
  }

  public isMarketingUser(): boolean {
    const userGroups = this.getUserGroups();
    return userGroups.includes('nfl-idh-marketing');
  }

  public getHeaders() {
    return { 'X-Org-Id': this.userDetails['custom:orgId'] ?? '' };
  }
}
